export const escapeSepcialChars = str =>
  str.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
